module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "top": _vm.snackBar.y === 'top'
    },
    model: {
      value: (_vm.snackBar.snackbar),
      callback: function($$v) {
        _vm.$set(_vm.snackBar, "snackbar", $$v)
      },
      expression: "snackBar.snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackBar.text) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "color": "white"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackBar.snackbar = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e581da2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 567
// module chunks = 1